import { ref } from 'vue';
import { useEcho } from '@laravel/echo-vue';
import { EchoBroadcast } from '@apparatix/constants/EchoBroadcast';

/**
 * Subscribe to tenant-wide (not per-user) broadcast events, e.g. site configuration
 * changes such as HAL feature flags. Mirrors useStateSync but on the tenant channel.
 */
export const useTenantSync = (tenantId: string) => {
  const channelName = ref(`tenants.${tenantId}.features`);

  const subscribe = <T>(eventName: keyof typeof EchoBroadcast.tenantEvent, callback: (data: T) => void) => {
    const { listen, stopListening } = useEcho<T>(channelName.value, eventName, eventData => {
      if (typeof callback === 'function') {
        callback(eventData);
      }
    });

    return [stopListening, listen];
  };

  return {
    subscribe,
  };
};
